import { Injectable } from '@angular/core';
import Dexie from 'dexie';
import { DBService } from './indexedDB/db.service';

export interface Settings {
  theme: string;
  lang: string;
}

export interface SettingswithID extends Settings {
  id: number;
}

@Injectable()
export class SettingsService {
  table: Dexie.Table<SettingswithID, number>;

  constructor(private dbservice: DBService) {
    this.table = this.dbservice.table('settings');
  }

  getAll() {
    return this.table.get(1);
  }

  add(data) {
    return this.table.add(data);
  }

  update(id, data) {
    return this.table.update(id, data);
  }

  remove(id) {
    return this.table.delete(id);
  }
}
